import { render, staticRenderFns } from "./CustomersModule.vue?vue&type=template&id=f0d553ce"
import script from "./CustomersModule.vue?vue&type=script&lang=js"
export * from "./CustomersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports